var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMeasurementTape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 20V11.5C5 9.13333 5.825 7.125 7.475 5.475C9.125 3.825 11.1333 3 13.5 3C15.8667 3 17.875 3.825 19.525 5.475C21.175 7.125 22 9.13333 22 11.5C22 13.8667 21.175 15.875 19.525 17.525C17.875 19.175 15.8667 20 13.5 20H5ZM7 18H13.5C15.3 18 16.8333 17.3667 18.1 16.1C19.3667 14.8333 20 13.3 20 11.5C20 9.7 19.3667 8.16667 18.1 6.9C16.8333 5.63333 15.3 5 13.5 5C11.7 5 10.1667 5.63333 8.9 6.9C7.63333 8.16667 7 9.7 7 11.5V18ZM13.5 15C14.4667 15 15.2917 14.6583 15.975 13.975C16.6583 13.2917 17 12.4667 17 11.5C17 10.5333 16.6583 9.70833 15.975 9.025C15.2917 8.34167 14.4667 8 13.5 8C12.5333 8 11.7083 8.34167 11.025 9.025C10.3417 9.70833 10 10.5333 10 11.5C10 12.4667 10.3417 13.2917 11.025 13.975C11.7083 14.6583 12.5333 15 13.5 15ZM13.5 13C13.0833 13 12.7292 12.8542 12.4375 12.5625C12.1458 12.2708 12 11.9167 12 11.5C12 11.0833 12.1458 10.7292 12.4375 10.4375C12.7292 10.1458 13.0833 10 13.5 10C13.9167 10 14.2708 10.1458 14.5625 10.4375C14.8542 10.7292 15 11.0833 15 11.5C15 11.9167 14.8542 12.2708 14.5625 12.5625C14.2708 12.8542 13.9167 13 13.5 13ZM2 20V15H4V20H2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMeasurementTape);
export default __webpack_public_path__ + "static/media/icon-measurement-tape.04b9f26b119d8c2297b5265c5366dd4b.svg";
export { ForwardRef as ReactComponent };